import React from 'react';

function Making() {
    return (
        <div>
            준비중입니다...
        </div>
    );
}

export default Making;